import { useMutation } from '@tanstack/react-query'
import { sendChatMessage, SendChatMessageRequest } from 'api/message'
import { useAuthContext } from 'components/auth'

interface UseSendMessageMutation {
  onSuccess?: () => void
}

export function useSendMessageMutation(options?: UseSendMessageMutation) {
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async (data: SendChatMessageRequest) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }
      return sendChatMessage(company.id, data)
    },
    ...options,
  })
}
